import { KTextField, KTextFieldProps } from 'components/core/KTextField'
import { useCurrentStore } from 'hooks'
import {
  ForwardRefExoticComponent,
  RefAttributes,
  forwardRef,
  useEffect,
  useState,
  ChangeEvent,
} from 'react'

export interface KMoneyFieldProps
  extends Omit<KTextFieldProps, 'type' | 'onKeyDown'> {}

interface KMoneyFieldState {
  value: number
  formattedValue: string
}

export const KMoneyField: ForwardRefExoticComponent<
  Omit<KMoneyFieldProps, 'ref'> & RefAttributes<HTMLDivElement>
> = forwardRef((props, ref) => {
  const { onChange, onBlur, value, ...restProps } = props
  const { formatCurrency } = useCurrentStore()

  const [state, setState] = useState<KMoneyFieldState>({
    value: isNaN(Number(value)) ? 0 : Number(value),
    formattedValue: formatCurrency(isNaN(Number(value)) ? 0 : Number(value)),
  })

  useEffect(() => {
    setState({
      value: isNaN(Number(value)) ? 0 : Number(value),
      formattedValue: formatCurrency(isNaN(Number(value)) ? 0 : Number(value)),
    })
  }, [value, formatCurrency])

  const handleValueChange = (newValue: number): void => {
    if (newValue >= 0 && newValue <= 99999) {
      setState({
        value: newValue,
        formattedValue: formatCurrency(newValue),
      })
      if (onChange) {
        onChange({ target: { name: props.name, value: newValue } } as any)
      }
    }
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value.replace(/[^0-9]/g, '')
    const numericValue = parseInt(inputValue, 10) / 100
    handleValueChange(numericValue)
  }

  return (
    <KTextField
      ref={ref}
      value={state.formattedValue}
      onChange={handleChange}
      inputMode="numeric"
      slotProps={{
        htmlInput: {
          inputMode: 'numeric',
          pattern: '[0-9]*',
        },
      }}
      {...restProps}
    />
  )
})
